import NavigationCom from './new-site/navigation'
import OrderCom from './new-site/order'
import SemanticUICom from './panel/semantic-ui'
import EventEmitter from "events";

const app = { events: new EventEmitter() }

document.addEventListener('DOMContentLoaded', function() {
    NavigationCom()
    OrderCom()
    SemanticUICom(app)
})
